/**
 * @author Falk Brueckner <fabr@fabid.de>
 */
import React from 'react';
import ReactMarkdown, { uriTransformer } from 'react-markdown';
import styles from './Markdown.scss';
import IDomELement from '../interfaces/IDomElement';
import cx from '../utils/cx';

// type INodeType = typeof NodeType;

type IReactMarkdown = typeof ReactMarkdown;

export interface IMarkdownProps extends IDomELement {
    children: React.ReactNode;
    // linkTarget?: string | any; // ReactMarkdown.LinkTargetResolver;
    linkTarget?: '_self' | '_blank' | '_parent' | '_top';
    disallowedElements?: IReactMarkdown['disallowedElements'];
    variant?: 'legal' | 'propertyDescription' | 'publicPage' | 'default';
}

/**
 * render markdown as HTML with react-markdown
 */
const Markdown: React.FC<React.PropsWithChildren<IMarkdownProps>> = ({ children, className, variant = 'default', linkTarget = '_self', disallowedElements = null }): React.ReactElement<any> => {
    // const cn = [styles.markdown, className].filter((i) => i).join(' ');

    return (
        <ReactMarkdown
            className={cx(styles.markdown, className, styles[variant])}
            linkTarget={linkTarget}
            disallowedElements={disallowedElements}
            // transformLinkUri={(uri: string) => {
            //     return null;
            // }}
            transformLinkUri={(uri: string) => {
                return uri ? uriTransformer(uri.indexOf('#') === 0 ? location.protocol + '//' + location.host + location.pathname + uri : uri) : null;
            }}
            unwrapDisallowed
        >
            {children}
        </ReactMarkdown>
    );
};

export default Markdown;
